export default "__VITE_ASSET__CLukvQq3__"